'use client'

import { toast } from 'react-toastify'

const Toast = (status: string, message: string) => {
  const toastType = (status: string) => {
    switch (status) {
      case 'success':
        return toast.success
      case 'error':
        return toast.error
      case 'info':
        return toast.info
      case 'warning':
        return toast.warn
      default:
        return toast
    }
  }

  const showToast = toastType(status)

  showToast(message, {
    autoClose: 2500,
    position: 'top-right',
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    progress: undefined,
    draggable: true,
    theme: 'colored',
    style: {
      borderRadius: '12px'
    }
  })
}

export default Toast
